import Swiper from "swiper";
import { Pagination, Navigation, Autoplay } from "swiper/modules";
import "swiper/css";

// Make available to inline reinit
window.Swiper = Swiper;
window.SwiperPagination = Pagination;
window.SwiperNavigation = Navigation;

// Initialize after full page load to avoid early sizing
// if (document.readyState === "loading") {
//     initAllSwipers();
// } else {
//     window.addEventListener("load", initAllSwipers, { once: true });
// }

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAllSwipers);
} else {
    initAllSwipers();
    const slides = document.querySelectorAll(".swiper-slide");
    slides.forEach((i) => {
        i.style.opacity = '1';
    })
}

// Optional: Re-run Swipers after Sprig (HTMX) replaces content
document.addEventListener("htmx:afterSwap", (event) => {
    if (event.target.querySelector("#decor-slider")) {
        destroySwiper(window.decorSwiper);
        window.decorSwiper = initDecorSwiper();
    }
});

// Util to destroy safely
function destroySwiper(swiper) {
    if (swiper && typeof swiper.destroy === "function") {
        swiper.destroy(true, true);
    }
}

// Swiper inits
function initDecorSwiper() {
    const el = document.querySelector("#decor-slider");
    if (!el) return null;

    return new Swiper(el, {
        modules: [Pagination],
        slidesPerView: 1,
        pagination: {
            el: ".swiper-pagination",
            type: "bullets",
            clickable: true,
        },
    });
}

function initHeroSwiper() {
    const el = document.querySelector(".hero-slider");
    if (!el) return null;

    return new Swiper(el, {
        modules: [Pagination, Autoplay],
        slidesPerView: 1,
        speed: 800,
        pagination: {
            el: ".swiper-pagination",
            type: "bullets",
            clickable: true,
        },
        autoplay: {
            delay: 5000,
        },
    });
}

function initBrochureSwiper() {
    const el = document.querySelector(".brochure-slider");
    if (!el) return;
    return new Swiper(el, {
        modules: [Navigation, Pagination],
        slidesPerView: 1.5,
        spaceBetween: 32,
        breakpoints: {
            768: { slidesPerView: 2.5 },
            1024: { slidesPerView: 3.5 },
            1440: { slidesPerView: 4 },
        },
        observer: true,
        observeParents: true,
        resizeObserver: true,
        preloadImages: true,
        updateOnImagesReady: true,
        watchSlidesProgress: true,
    });
}

function initInspoSwiper() {
    const el = document.querySelector(".inspo-slider");
    if (!el) return;
    return new Swiper(el, {
        modules: [Navigation, Pagination, Autoplay],
        slidesPerView: 1.5,
        spaceBetween: 32,
        breakpoints: {
            768: { slidesPerView: 2.5 },
            1024: { slidesPerView: 3.5 },
            1440: { slidesPerView: 4 },
        },
        watchSlidesProgress: true,
        autoplay: {
            delay: 5000,
        },
    });
}

function standardSwiper() {
    const els = document.querySelectorAll(".standard-slider");
    if (!els.length) return;

    els.forEach((el) => {
        // Avoid double-init per element
        if (el.__swiperInited) return;
        const next = el.querySelector(".swiper-button-next");
        const prev = el.querySelector(".swiper-button-prev");

        // Guard: only init when the element actually has controls
        if (!next || !prev) return;

        const instance = new Swiper(el, {
            modules: [Navigation, Pagination, Autoplay],
            slidesPerView: 1.5,
            slidesPerGroup: 1,
            spaceBetween: 32,
            speed: 800,
            breakpoints: {
                768: { slidesPerView: 2.5 },
                1024: { slidesPerView: 3.5 },
                1440: { slidesPerView: 4 },
            },
            observer: true,
            observeParents: true,
            resizeObserver: true,
            preloadImages: true,
            updateOnImagesReady: true,
            watchSlidesProgress: true,
            navigation: {
                nextEl: next,
                prevEl: prev,
            },
            autoplay: {
                delay: 5000,
                pauseOnMouseEnter: true,
            },
            on: {
                init(sw) {
                    // Reveal once sized to avoid layout flash
                    el.classList.remove("opacity-0");
                },
                imagesReady(sw) {
                    if (typeof sw.update === "function") sw.update();
                    el.classList.remove("opacity-0");
                },
            },
        });
        el.__swiperInited = true;
        // Recalculate after full load and fonts rendering
        window.addEventListener("load", () => {
            if (instance && typeof instance.update === "function") instance.update();
            el.classList.remove("opacity-0");
        }, { once: true });
        if (document.fonts && document.fonts.ready) {
            document.fonts.ready.then(() => {
                if (instance && typeof instance.update === "function") instance.update();
                el.classList.remove("opacity-0");
            });
        }
    });
}

function initTimelineSwiper() {
    const els = document.querySelectorAll(".timeline-slider");
    if (!els.length) return; // check for empty NodeList
    els.forEach((el) => {
        new Swiper(el, {
            modules: [Navigation, Pagination],
            slidesPerView: 1,
            spaceBetween: 0,
            breakpoints: {
                768: { slidesPerView: 2 },
                // 1024: { slidesPerView: 3 },
                1440: { slidesPerView: 4 },
            },
            watchSlidesProgress: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
        });
    });
}

function initAllSwipers() {
    initHeroSwiper();
    initBrochureSwiper();
    initInspoSwiper();
    initTimelineSwiper();
    standardSwiper();
    window.decorSwiper = initDecorSwiper();
}
